import React from 'react';
import { cn } from '../../utils';

interface SidebarSkeletonProps {
  rows?: number;
  className?: string;
}

function SkeletonRow() {
  return (
    <div className="rounded-xl border border-slate-800/80 bg-slate-950/40 p-3">
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded-full bg-slate-800 motion-safe:animate-sidebar-shimmer motion-reduce:animate-none" />
        <div className="min-w-0 flex-1 space-y-2">
          <div className="h-3.5 w-2/3 rounded-full bg-slate-800 motion-safe:animate-sidebar-shimmer motion-reduce:animate-none" />
          <div className="h-3 w-5/6 rounded-full bg-slate-800/90 motion-safe:animate-sidebar-shimmer motion-reduce:animate-none" />
        </div>
      </div>
    </div>
  );
}

export function SidebarSkeleton({ rows = 7, className }: SidebarSkeletonProps) {
  return (
    <div className={cn('space-y-4 opacity-100 transition-opacity duration-150', className)}>
      <div>
        <div className="mb-2 h-3 w-24 rounded-full bg-slate-800 motion-safe:animate-sidebar-shimmer motion-reduce:animate-none" />
        <div className="space-y-2">
          {Array.from({ length: rows }).map((_, index) => (
            <SkeletonRow key={index} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SidebarSkeleton;
